/**
 * Whether this document is running the app, for the components mounted outside it.
 *
 * The site header, the footer and the help panel are on every page django serves, SPA or
 * not, and they are built through `~/vue/createApp` - so they have a `$router` even on a
 * page with no `#spa-root` for it to render into. Pushing there would change the url and
 * leave the document showing what it already showed. Ask this before routing.
 *
 * Its own module, with no imports, for the reason `~/vue/createApp` does not import the
 * router either: `spa/mount` reaches the whole route table, and the header is loaded long
 * before it in the entry.
 *
 * Not reactive on purpose: the mounts race each other on document ready, so read it when
 * the click happens rather than caching it in a computed.
 */
let mounted = false;

export function markSpaMounted () {
    mounted = true;
}

export function isSpaMounted () {
    return mounted;
}
